<template>
  <div class="auth-layout container-fluid d-flex flex-column">
    <div class="row d-flex flex-fill">
      <div class="col-lg-8 bg-trans-20-dark-blue flex-fill d-flex ">
        <div class="align-self-center text-white text-left pl-md-5">
          <h1 class="logo">SHINKANOTE</h1>
          <h3>The world's most minimalistic writing app</h3>
        </div>
      </div>
      <div
        class="col-lg-4 bg-trans-90-dark-blue flex-fill align-content-center d-flex justify-content-center"
      >
        <div class="align-self-center w-100 auth-container">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout"
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 4em;
  color: #fff;
  font-weight: 900;
  text-shadow: 8px 8px 24px rgba(0, 0, 0, 0.5);
}
.auth-layout {
  min-height: 100vh;
}
.auth-container {
  max-width: 400px;
}
</style>
